/**
 * 布局工具 - WebView 内占满全屏，其他场景限宽居中
 */
import { isEmbedded } from "./chief-bridge";

/**
 * 获取容器的限宽样式
 * - App WebView 内：不限宽，占满全屏
 * - 其他场景（手机浏览器、iPad、PC）：限制最大宽度并居中
 * @param maxWidth 最大宽度，默认 640px
 */
export function getContainerStyle(maxWidth = 640): string {
  return isEmbedded() ? "" : `max-width: ${maxWidth}px; margin: 0 auto;`;
}
